import React from 'react';
import theme from '@src/styles/theme';
import { useTranslation } from 'react-i18next';
import { Button, useMediaQuery } from '@mui/material';
import { StyledActionsSurvey } from './index.style';

const ActionsButton = ({
  onPrevious,
  onContinue,
  hasButtonNextDisabled,
  hasButtonPreviousDisabled,
  hasButtonFinish,
  onSkip,
}) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledActionsSurvey
      isMobile={isMobile}
      hasButtonNextDisabled={hasButtonNextDisabled}
      hasButtonPreviousDisabled={hasButtonPreviousDisabled}
    >
      {!isMobile && (
        <div
          role="button"
          tabIndex="0"
          className="skip-action"
          onClick={onSkip}
        >
          {t('later')}
        </div>
      )}
      <div className="actions-btn">
        {!isMobile && (
          <Button
            disabled={hasButtonPreviousDisabled}
            onClick={onPrevious}
            className="prev-button"
          >
            {t('back')}
          </Button>
        )}
        <Button
          onClick={onContinue}
          disabled={hasButtonNextDisabled}
          variant="contained"
          className="next-button"
        >
          {hasButtonFinish ? t('finish') : t('continue')}
        </Button>
      </div>
    </StyledActionsSurvey>
  );
};

export default ActionsButton;
